import authInterceptor from "../AuthInterceptor";

export const ConfigurationAPI = {
    getCofigData: (config) =>
        authInterceptor.get(`ranking-api/save-configurations/`, config)
            .then((response) => response.data)
            .catch((error) => error.response),
    postCofigData: (bodyData) =>
        authInterceptor.post(`ranking-api/save-configurations/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),

}